import React from "react";

import {
  Box,
  Button,
  Column,
  Columns,
  Control,
  Field,
  Input,
  Modal,
  Section,
  Table,
  Title,
} from "@allxsmith/bestax-bulma";

import WorkTotals from "../WorkTotals/WorkTotals";
import { formatCurrency } from "../../utils";

export default function FinalizeModal({ open, setOpen, quote, onFinalize }) {
  const onClick = () => {
    onFinalize();
    setOpen(false);
  };

  const checkZeros = value => {
    return !value || value === 0 || value === "0";
  };

  const vehicle = quote.vehicle ? quote.vehicle : {};

  let zeros = false;
  let supplierTotals = {};
  let labourCosts = 0;

  quote.estimated_work_items.forEach(item => {
    labourCosts += item.estimated_labour_cost;
    if (
      checkZeros(item.estimated_labour_cost) ||
      checkZeros(item.estimated_customer_labour_cost)
    ) {
      zeros = true;
    }
    item.parts
      .filter(part => part.supplier)
      .forEach(part => {
        if (
          checkZeros(part.estimated_cost) ||
          checkZeros(part.estimated_customer_cost)
        ) {
          zeros = true;
        }
        if (!supplierTotals[part.supplier.display_name]) {
          supplierTotals[part.supplier.display_name] = 1 * part.estimated_cost;
        } else {
          supplierTotals[part.supplier.display_name] += 1 * part.estimated_cost;
        }
      });
  });

  const customer_label = quote.customer
    ? ` - (${quote.customer.display_name})`
    : "";
  const customer2_label = quote.customer2
    ? ` - (${quote.customer2.display_name})`
    : "";

  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <Modal
      closeOnBlur
      active={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Modal.Content>
        <Section style={{ backgroundColor: "white" }}>
          <Title className="is-centered">
            Are you sure you want to finalize?
          </Title>
          <Columns isMultiline>
            <Column>
              <p className="is-centered">
                Verify the following details before confirming:
              </p>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Field>
                <label className="label label">Registration</label>
                <Control className="registration-wrapper">
                  <Input
                    className="registration-field"
                    type="text"
                    name="registration"
                    value={vehicle.registration}
                    disabled
                  />
                </Control>
              </Field>
            </Column>
            <Column>
              <Field>
                <Control>
                  <label className="label">Make</label>
                  <Input
                    type="text"
                    name="make"
                    value={vehicle.make}
                    readOnly
                    disabled
                  />
                </Control>
              </Field>
            </Column>
            <Column>
              <Field>
                <label className="label">Model</label>
                <Input
                  type="text"
                  name="model"
                  value={vehicle.model ? vehicle.model.name : ""}
                  readOnly
                  disabled
                />
              </Field>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Field>
                <label className="label">Estimated Total Labour Cost</label>
                <Input
                  type="text"
                  name="labour"
                  value={formatCurrency(labourCosts)}
                  readOnly
                  disabled
                />
              </Field>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <label className="label">Supplier Parts Breakdown</label>
              <Table>
                <thead>
                  <th>Supplier</th>
                  <th>Estimated Parts Cost</th>
                </thead>
                <tbody>
                  {Object.keys(supplierTotals).map(supplier => (
                    <tr>
                      <td>{supplier}</td>
                      <td>{formatCurrency(supplierTotals[supplier])}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Box>
                <Title size="6">Customer Quote{customer_label}</Title>
                <WorkTotals
                  workItems={quote.estimated_work_items}
                  allItems={false}
                  chargeable={false}
                  labourFieldName="estimated_customer_labour_cost"
                  partFieldName="estimated_customer_cost"
                />
              </Box>
            </Column>
            <Column>
              <Box>
                <Title size="6">
                  Customer 2 Quote{customer2_label}
                </Title>
                <WorkTotals
                  workItems={quote.estimated_work_items}
                  allItems={false}
                  chargeable={true}
                  labourFieldName="estimated_customer_labour_cost"
                  partFieldName="estimated_customer_cost"
                />
              </Box>
            </Column>
          </Columns>
          {zeros && (
            <Columns isMultiline>
              <Column>
                <p className="is-centered">
                  <b>WARNING</b>: One or more items has been estimated to have a
                  cost/charge of £0. Please double check and confirm before
                  approving!
                </p>
              </Column>
            </Columns>
          )}
          <Columns isMultiline>
            <Column>
              <Button color="info" onClick={onClick} isFullWidth>
                Finalize
              </Button>
            </Column>
          </Columns>
        </Section>
      </Modal.Content>
    </Modal>
  );
}
